import CrossProductAnalytics from '../common/CrossProductAnalytics';

export enum AxeDevToolsMobileAmplitudeEvents {
  CLICK_CONTACT_US = 'conversion:click:contactUs'
}

export default class AxeDevtoolsMobileAnalytics extends CrossProductAnalytics<AxeDevToolsMobileAmplitudeEvents> {}
